<div class="container">
  <div class="main-hero-div">
    <div class="hero-img-div">
      <div class="hero-section-img-background">
        <img src="assets/about-us-background.png"/>
      </div>
<!--      <div class="hero-section-img">-->
      <img src="assets/about-us.png"/>
<!--      </div>-->
    </div>
    <div class="hero-div">
      <div class="hero-title">
        <p class="note" i18n>Who we are?</p>
        <h1 i18n>About us</h1>
        <p i18n>Welcome to Akl Bayti, where we bring the warmth and authenticity of home-cooked meals directly to your
          doorstep.
        </p>
      </div>
      <img class="first-right-header-Image" src="assets/merchant-landing-page/rectangle-yellow-icon.png"/>
    </div>
  </div>
</div>
